// extracted by mini-css-extract-plugin
module.exports = {"SortLabel":"SortingLabel_SortLabel__3YV9t","SortLabel__arrows":"SortingLabel_SortLabel__arrows__15Mjx","_active":"SortingLabel__active__2Ksc-"};